// src/pages/ListagemProdutosGpt.js
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useApi } from "../hooks/useApi";
import Header from "../components/Form/Header";
import MainContent from "../components/Form/MainContent";
import FooterCart from "../components/Form/FooterCart";
import { formatCurrency } from "../utils/numberUtils";
import "./ListagemProdutosGpt.css";
import { applyImageFallback } from '../utils/imageUtils';

const ListagemProdutosGpt = () => {
  const { buildApiUrl, fetchData } = useApi();
  const navigate = useNavigate();

  const [grupos, setGrupos] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [grupoAtivo, setGrupoAtivo] = useState(null);

  const sectionsRef = useRef({}); // refs para cada grupo

  useEffect(() => {
  const fetchAll = async () => {
    try {
      const gruposRes = await fetchData('/GrupoDelivery');
      setGrupos(gruposRes);

      const allItems = [];

      // para cada grupo, busca os produtos correspondentes
      for (const group of gruposRes) {
        const itemsResult = await fetchData(
          `/ProdutoDelivery/ProdutosByGrupo?grupoId=${group.id}`
        );

        // adiciona grupoId em cada produto (caso a API não retorne)
        const itemsWithGroup = itemsResult.map((item) => ({
          ...item,
          grupoId: group.id,
        }));

        allItems.push(...itemsWithGroup);
      }

      setProdutos(allItems);

      if (gruposRes.length > 0) {
        setGrupoAtivo(gruposRes[0].id);
      }
    } catch (err) {
      console.error("Erro ao carregar dados", err);
    }
  };
  fetchAll();
}, []);


  const handleGrupoClick = (grupoId) => {
    setGrupoAtivo(grupoId);
    sectionsRef.current[grupoId]?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    const onScroll = () => {
      const scrollPos = window.scrollY;
      let active = grupoAtivo;

      grupos.forEach((g) => {
        const section = sectionsRef.current[g.id];
        if (section) {
          const offsetTop = section.offsetTop;
          if (scrollPos >= offsetTop - 100) {
            active = g.id;
          }
        }
      });

      if (active !== grupoAtivo) {
        setGrupoAtivo(active);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [grupos, grupoAtivo]);


  const handleProdutoClick = (produto) => {
    navigate(`/itemdetails/${produto.id}`, { state: { itemSel: produto } });
  };

  return (
    <>
      <Header urlBack="/ordermenu" titulo="Cardápio" />

      {/* Grupos no topo */}
      <div className="grupos-topo">
        {grupos.map((g) => (
          <div
            key={g.id}
            className={`grupo-item ${grupoAtivo === g.id ? "ativo" : ""}`}
            onClick={() => handleGrupoClick(g.id)}
          >
            {g.descricao}
          </div>
        ))}
      </div>

      {/* Conteúdo com scroll e seções */}
      <MainContent>
        {grupos.map((g) => (
          <div
            key={g.id}
            ref={(el) => (sectionsRef.current[g.id] = el)}
            className="grupo-section"
          >
            <h2 className="grupo-titulo">{g.descricao}</h2>
            <div className="produtos-grid">
              {produtos
                .filter((p) => p.grupoId === g.id)
                .map((item) => (
                  <div
                    key={item.id}
                    className="produto-card"
                    onClick={() => handleProdutoClick(item)}
                  >
                    <img
                      src={
                        item.imagemId
                          ? buildApiUrl('/ProdutoDelivery/ProdutoImagemArquivo', { produtoId: item.id })
                          : "/images/image_default.jpg"
                      }
                      alt={item.descricao}
                      className="produto-img"
                      onError={applyImageFallback}
                    />
                    <div className="produto-info">
                      <h3>{item.descricao}</h3>
                      {item.ingredientes && (
                        <p className="ingredientes">{item.ingredientes}</p>
                      )}
                      <p className="preco">{formatCurrency(item.preco)}</p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </MainContent>

      <FooterCart />
    </>
  );
};

export default ListagemProdutosGpt;
